import React from "react";

const LazyForgotPassword = React.lazy(() => import("./forgot-password"));

const ForgotPassword = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/loader.svg' /></div>}>
    <LazyForgotPassword {...props} />
  </React.Suspense>
);

export default ForgotPassword;
